import { useState } from 'react';
import { skills } from '../../portfolio';
import ScrollReveal from '../ScrollReveal/ScrollReveal';
import { CATEGORIES } from './skillCategories';
import './Skills.css';

const matchCategory = (skill, category) => {
  if (!category || category.id === 'all') return true;
  const lower = skill.toLowerCase();
  return category.keywords?.some((kw) => lower.includes(kw)) ?? false;
};

const Skills = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  if (!skills.length) return null;

  const category =
    CATEGORIES.find((c) => c.id === activeCategory) ?? CATEGORIES[0];
  const filteredSkills = skills.filter((skill) =>
    matchCategory(skill, category)
  );

  return (
    <section className='section skills' id='skills'>
      <ScrollReveal>
        <h2 className='section__title'>Skills</h2>
      </ScrollReveal>

      <ScrollReveal delay={100}>
        <div className='skills__filters' role='tablist'>
          {CATEGORIES.map((cat) => (
            <button
              key={cat.id}
              type='button'
              role='tab'
              aria-selected={activeCategory === cat.id}
              className={`skills__filter-btn ${
                activeCategory === cat.id ? 'skills__filter-btn--active' : ''
              }`}
              onClick={() => setActiveCategory(cat.id)}
            >
              {cat.label}
            </button>
          ))}
        </div>
      </ScrollReveal>

      <div className='skills__list' key={activeCategory}>
        {filteredSkills.map((skill, index) => (
          <ScrollReveal key={`${skill}-${index}`} delay={index * 30} direction='scale'>
            <span className='skills__list-item btn btn--plain'>{skill}</span>
          </ScrollReveal>
        ))}
      </div>

      {filteredSkills.length === 0 && (
        <p className='skills__empty'>No skills in this category.</p>
      )}
    </section>
  );
};

export default Skills;
